/* global axios */
import ApiClient from './ApiClient';

class MfaAPI extends ApiClient {
  constructor() {
    super('profile/mfa', { accountScoped: false });
  }

  enable(password) {
    return axios.post(`${this.url}`, { password });
  }

  beginReplacement(password) {
    return axios.post(`${this.url}/replacement`, { password });
  }

  verify(otpCode, password) {
    return axios.post(`${this.url}/verify`, { otp_code: otpCode, password });
  }

  disable(password, { otpCode, backupCode } = {}) {
    return axios.delete(this.url, {
      data: { password, otp_code: otpCode, backup_code: backupCode },
    });
  }

  regenerateBackupCodes(otpCode) {
    return axios.post(`${this.url}/backup_codes`, { otp_code: otpCode });
  }

  rebind(password, { otpCode, backupCode } = {}) {
    return axios.post(`${this.url}/rebind`, {
      password,
      otp_code: otpCode,
      backup_code: backupCode,
    });
  }

  rebindVerify(otpCode, password) {
    return axios.post(`${this.url}/rebind_verify`, {
      otp_code: otpCode,
      password,
    });
  }
}

export default new MfaAPI();
